import { useState } from 'react'
import { colors } from '../colors'
import { FilterBar, PageContainer, PageHeader, ThemeCard } from '../components'
import { BargainUserInfo, Post, Theme } from '../types'

const styles: Record<string, React.CSSProperties> = {
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: '16px 0',
    backgroundColor: colors['keijiban-coral-bg'],
  },
  title: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: colors['keijiban-brown'],
    marginBottom: '0',
  },
  themesContainer: {
    backgroundColor: colors.white,
    paddingBottom: '80px', // フッターの高さ分の余白を確保
  },
}

interface Chain {
  id: number
  name: string
  logo_url?: string | null
}

interface ThemeListProps {
  themes: Theme[]
  thumbnail_posts: Post[]
  bargain_user_info: BargainUserInfo
  followed_chains?: Chain[]
}

const ThemesList: React.FC<ThemeListProps> = ({
  themes,
  thumbnail_posts,
  bargain_user_info,
  followed_chains = [],
}) => {
  const [filterType] = useState<'all' | 'following' | 'want_to_eat' | 'themes' | string>('themes')
  const [selectedChain] = useState<string | null>(null)
  const [isLoadingFilteredPosts] = useState(false)

  const theme_card_props_list = themes.map((theme) => {
    const thumbnail_post = thumbnail_posts.find(
      (post) => post.bargain_message_board_theme_id === theme.id
    )

    return {
      theme: theme,
      thumbnail_post: thumbnail_post,
    }
  })

  return (
    <>
      <PageContainer maxWidth="640px">
        <PageHeader title="みんなのおいしい口コミ" bargain_user_info={bargain_user_info}/>

        <FilterBar
          filterType={filterType}
          isLoadingFilteredPosts={isLoadingFilteredPosts}
          bargain_user_info={bargain_user_info}
          followed_chains={followed_chains}
          selectedChain={selectedChain}
          currentPage="themes"
        />

        <div style={styles.titleSection}>
          <h2 style={styles.title}>お題一覧</h2>
        </div>

        <div style={styles.themesContainer}>
          {theme_card_props_list.map((theme_card_props) => (
            <ThemeCard
              key={theme_card_props.theme.id}
              theme={theme_card_props.theme}
              thumbnail_post={theme_card_props.thumbnail_post}
              bargain_user_info={bargain_user_info}
            />
          ))}
        </div>
      </PageContainer>
    </>
  )
}

export default ThemesList
